export default __webpack_public_path__ + "/dist/images/image7.3b8e4b0c054a9b4654fb88b3860ce0d7.png";